import { BooleanOrListOfString } from '../../core/bool-or-list.js';
import { DataModel } from '../../dto/dto.js';

export enum OpenAccessProtocolType {
  PerEvent = 'PerEvent',
  PerSeat = 'PerSeat',
  StagedPerSeat = 'StagedPerSeat',
  LimitedTime = 'LimitedTime',
  LimitedUses = 'LimitedUses',
  FlexiblePass = 'FlexiblePass',
  GymAccess = 'GymAccess',
}

export abstract class IEventOpenAccessProtocol {
  abstract cloneEventConfiguration(): Map<string, BooleanOrListOfString>;

  abstract isEventAssignedToPass(args: { eventId: string, passVariationId: string }): boolean;

  abstract getAssignedEventIdsForPass(args: { passVariationId: string }): string[];

  abstract isEventAssignedToTemplate({ eventId }: { eventId: string }): boolean;

  static convertFromLegacyEventList(events: string[]): Map<string, BooleanOrListOfString> {
    const eventMap = new Map<string, BooleanOrListOfString>();
    for(const eventId of events) {
      eventMap.set(eventId, BooleanOrListOfString.fromBoolean(true));
    }

    return eventMap;
  }

  static convertToLegacyEventList(events: Map<string, BooleanOrListOfString>): string[] | null {
    const eventList: string[] = [];
    for(const [k, v] of events) {
      if(v.isList) return null; // list of variation ids is not backwards compatible
      if(v.isBoolean && v.booleanValue) eventList.push(k);
    }

    return eventList;
  }
}

export abstract class OpenAccessProtocol extends DataModel {
  abstract get type(): OpenAccessProtocolType;
  abstract applyTemplateChanges(other: this): this;
}
